import type { BackgroundTaskList, BackgroundTaskRepository } from '@/domain/backgroundTask/BackgroundTask'

export function listBackgroundTasks(repository: BackgroundTaskRepository): Promise<BackgroundTaskList> {
  return repository.list()
}

export function loadBackgroundTaskMessages(repository: BackgroundTaskRepository, taskId: string): Promise<string[]> {
  return repository.messages(taskId)
}
